var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9.01421 7.42132"}},[_c('title',[_vm._v(_vm._s(_vm.alt))]),_c('polyline',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"2px"},attrs:{"points":"0.707 3.707 3.007 6.007 8.307 0.707"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }